import React, { useEffect } from 'react';
import classnames from 'classnames';
import find from 'lodash/find';
import Footer from '../Footer/Footer';

import seo from 'shared/lib/seo';
import LICENSES from '../../constants/licenses';

import styles from './Licenses.module.css';

const Licenses = () => {
  const { name } = find(LICENSES.personal, person => person);
  useEffect(() => {
    seo.setProps({
      title: 'Licenses - Sure',
    });
  }, []);

  return (
    <div>
      <div className={styles.header}>
        <div className={styles.container}>
          <h1 className={styles.title}>Licenses and Legal Information</h1>
          <p className={styles.description}>
            SURE, Inc., offers insurance and services through its licensed
            insurance agency Sure HIIS Insurance Services, LLC. Listed below are
            the respective license numbers for each state in which it operates.
          </p>
        </div>
      </div>

      <div className={styles.content}>
        <div className={styles.container}>
          <div className={styles.tableBlock}>
            <h2 className={styles.subheadline}>State Insurance Licenses</h2>
            <table className={styles.table}>
              <thead className={styles.table_header}>
                <tr>
                  <th
                    rowSpan="2"
                    className={classnames([
                      styles.middle,
                      styles.table_headerHeadline,
                    ])}
                  >
                    State
                  </th>
                  <th colSpan="2" className={styles.table_headerHeadline}>
                    Business Entity (Sure HIIS Insurance Services, LLC)
                  </th>
                </tr>
                <tr>
                  <th className={styles.table_headerHeadline}>License #</th>
                  <th className={styles.table_headerHeadline}>
                    License Type(s)
                  </th>
                </tr>
              </thead>
              <tbody>
                {LICENSES.states.map(row => (
                  <tr className={styles.table_row} key={row.state}>
                    <td className={styles.table_cell}>{row.state}</td>
                    <td className={styles.table_cell}>{row.number}</td>
                    <td className={styles.table_cell}>{row.type}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className={styles.tableBlock}>
            <h2 className={styles.subheadline}>Employee Licenses</h2>
            <table className={styles.table}>
              <thead className={styles.table_header}>
                <tr>
                  <th
                    className={classnames([
                      styles.table_headerHeadline,
                      styles.noMobile,
                    ])}
                  >
                    Employee Name
                  </th>
                  <th className={styles.table_headerHeadline}>State</th>
                  <th className={styles.table_headerHeadline}>License #</th>
                  <th className={styles.table_headerHeadline}>
                    License Type(s)
                  </th>
                </tr>
                <tr className={styles.isMobileRow}>
                  <th className={styles.table_headerHeadline} colSpan="3">
                    Employee Name{' '}
                    <span className={styles.table_headerText}>{name}</span>
                  </th>
                </tr>
              </thead>
              {LICENSES.personal.map(person => (
                <tbody key={person.name}>
                  {person.rows.map((row, i) => (
                    <tr key={row.state} className={styles.table_row}>
                      {i === 0 && (
                        <td
                          className={classnames([
                            styles.table_cell,
                            styles.noMobile,
                          ])}
                          rowSpan={person.rows.length}
                        >
                          {person.name}
                        </td>
                      )}
                      <td className={styles.table_cell}>{row.state}</td>
                      <td className={styles.table_cell}>{row.number}</td>
                      <td className={styles.table_cell}>{row.type}</td>
                    </tr>
                  ))}
                </tbody>
              ))}
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Licenses;
